import { render } from "./professional-certification.vue?vue&type=template&id=21f52956"
import script from "./professional-certification.vue?vue&type=script&lang=js"
export * from "./professional-certification.vue?vue&type=script&lang=js"
script.render = render

export default script